<template>
  <div class="register" data-aos="zoom-in">
    <h1 class="log">Log in</h1>
    <p class="text">
      Go to your account to get a discount card and to track parcels.
    </p>
    <base-google @click="registerWithGoogle"></base-google>
    <p class="other-way">or log in with Email</p>
    <input type="email" placeholder="Email" v-model="email" />
    <p v-if="!emailIsValid" class="error">{{ emailErrorMessage }}</p>
    <div class="password-wrapper">
      <input
        :type="passwordIsVisible ? 'text' : 'password'"
        placeholder="Password"
        v-model="password"
        class="password"
      />
      <button class="visibility-btn" @click="togglePasswordVisibility">
        <img v-if="!passwordIsVisible" src="/images/closeEye.svg" alt="" />
        <img v-else src="/images/openeye.svg" alt="" />
      </button>
      <p v-if="!passwordIsValid" class="error">{{ passwordErrorMessage }}</p>
    </div>
    <base-button @click="registerWithEmail">Log in</base-button>
    <p class="create-acc">
      Don't have an account?
      <button @click="switchToLogin" class="dynamic-comp">Create</button>
    </p>
  </div>
</template>

<script>
import validation from "./helper/validation.js";

export default {
  data() {
    return {
      email: "",
      password: "",
      emailErrorMessage: "",
      passwordErrorMessage: "",
      passwordIsValid: true,
      emailIsValid: true,
      passwordIsVisible: false,
    };
  },


  methods: {
    togglePasswordVisibility() {
      this.passwordIsVisible = !this.passwordIsVisible;
  },

    async registerWithEmail() {
      try {
        await this.$store.dispatch("register/loginWithEmail", {
          email: this.email,
          password: this.password,
          router: this.$router
        }); 
        this.$store.dispatch('checkLoggedIn');
      } catch (error) {
        if (error.code === "auth/invalid-credential") {
          this.emailIsValid = false;
          this.passwordIsValid = false;
          this.passwordErrorMessage = "Incorrect login or password";
        }
      }
    },

    async registerWithGoogle() {
      try {
        await this.$store.dispatch("register/loginWithGoogle", this.$router)
      } catch (error) {
        this.errorMessage = error.message;
      }
    },

    switchToLogin() {
      this.$emit("switchToLogin");
    },
  },
  watch: validation,
};
</script>

<style scoped>
input {
  outline: none;
  border: none;
  height: 55px;
  padding: 18px 8px;
  border-bottom: 0.823px solid rgba(0, 0, 0, 0.8);
  font-size: 2.2rem;
}
</style>
